import LocalizedString from './LocalizedString';
import Option from './Option';
import DisplayRequirements from './DisplayRequirements';
import SliderLabel from './SliderLabel';

export default class QualityMentoringFormQuestion {
  public id: number;

  public idString: string;

  public mcId: string;

  public path: string;

  public type: string;

  public title: LocalizedString;

  public question: LocalizedString;

  public notes: LocalizedString;

  public resources: LocalizedString;

  public hint: LocalizedString;

  public options: Option[] = [];

  public children: QualityMentoringFormQuestion[] = [];

  public requires: DisplayRequirements;

  public columnHeaders: LocalizedString[] = [];

  public rowHeaders: LocalizedString[] = [];

  public columnDisplay = null;

  public sliderLabels: SliderLabel;

  public static createFromRow(row: any): QualityMentoringFormQuestion {
    const question = new QualityMentoringFormQuestion();
    question.id = row.id;
    if (row.id) {
      question.idString = row.id.toString().replace('.', '-');
    }
    if (row.mc_id) {
      question.mcId = row.mc_id;
    }
    question.path = `${row.parentId}_${row.id}`;
    question.type = row.type;
    if (row.requires) {
      question.requires = new DisplayRequirements(row.requires);
    }
    if (row.title_text) {
      question.title = new LocalizedString(row.title_text);
    }
    if (row.question_text) {
      question.question = new LocalizedString(row.question_text);
    }
    if (row.notes_text) {
      question.notes = new LocalizedString(row.notes_text);
    }
    if (row.resources_text) {
      question.resources = new LocalizedString(row.resources_text, true);
    }
    if (row.hint_text) {
      question.hint = new LocalizedString(row.hint_text);
    }

    if (row.labels_text) {
      question.sliderLabels = new SliderLabel(row.labels_text);
    }

    row.options?.forEach((optionRow: any) => {
      const option = new Option(optionRow);
      if (question.type === 'text-entry' || question.type === 'textarea-entry') {
        option.value = `${question.path}_${option.value}`;
      }
      question.options.push(option);
    });

    row.children?.forEach((childRow: any) => {
      const child = QualityMentoringFormQuestion.createFromRow(childRow);
      question.children.push(child);
      if (child.options.length) {
        question.options.push(...child.options);
      }
    });

    question.columnHeaders = QualityMentoringFormQuestion.getColumnHeaders(row);

    question.rowHeaders = QualityMentoringFormQuestion.getRowHeaders(row);

    if (row.column_display) {
      question.columnDisplay = row.column_display;
      for (const key in question.columnDisplay.values) {
        question.columnDisplay.values[key] = new LocalizedString(question.columnDisplay.values[key]);
      }
    }

    return question;
  }

  public static getColumnHeaders(row): LocalizedString[] {
    if (row.column_headers) {
      return row.column_headers.map((element) => {
        return new LocalizedString(element);
      });
    }
    return [];
  }

  public static getRowHeaders(row): LocalizedString[] {
    if (row.row_headers) {
      return row.row_headers.map((element) => {
        return new LocalizedString(element);
      });
    }
    return [];
  }
}
